import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';
import './leadDetailsApt.css';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const LeadDetailsApt = ({
  isCorporate = false,
  inputLabel = 'label',
  isSupply = false,
  isB2bAlliances = false,
  isApartment = false,
  LeadSource,
  sourceData,
  handleValue,
  pocSiteType = null,
  pocSiteTypeData = null,
  pocSubSiteTypeData = null,
  pocSubSiteType = null,
  supDropDownData,
  corDropDownData,
  appartmentDropDown,
  b2bDropDown,
  prefilledData = null,
  client_name=null,
  isDefalut,
  documentUploadUrl,
}) => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) {
      dd='0'+dd;
  } 
  if(mm<10) {
      mm='0'+mm;
  } 
  today = dd+'-'+mm+'-'+yyyy;
  
  const leadDtl = {
    name: '',
    sourceLead: { id: null, value: '' },
    alternateChannle: { id: null, value: '' },
    mainSource: { id: null, value: '' },
    tpPoc: '',
    contact_date: today,
    otherSource: '',
    interactionTypeLead: { id: null, value: '' },
    type_of_ev_charges:'',
    brand:'',
  };
  const leadSiteType = {
    typeSite: { id: null, value: '' },
    catLead: '',
  };

  const [leadDtls, setLeadDtls] = useState(leadDtl);
  const [leadsities, setLeadsities] = useState(leadSiteType);
  const [typeSubSite, setTypeSubSite] = useState({ id: null, value: '' });
  const [siteSubTypeOther, setSiteSubTypeOther] = useState('');
  const [leadSourceOther, setLeadSourceOther] = useState('');
  const [siteType, setSiteType] = useState();
  const [source, setSource] = useState();
  const [leadSource, setLeadSource] = useState();
  const [interactionType, setInteractionType] = useState();
  const [photos, setPhotos] = useState();

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setLeadDtls(leadDtl);
      setLeadsities(leadSiteType);
      setTypeSubSite({ id: null, value: '' });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        client_name,
        lead_source_id,
        lead_source,
        mainSource,
        alternateChannle,
        other_lead_source,
        site_type_id,
        site_type,
        site_sub_type,
        site_sub_type_id,
        other_poc_sites,
        contact_date,
        interaction_type_id,
        interaction_type
      } = prefilledData?.lead_data;
      setLeadDtls({
        ...leadDtls,
        name: client_name,
        contact_date: contact_date,
        sourceLead: { id: lead_source_id, value: lead_source },
        alternateChannle:{id: alternateChannle, value: alternateChannle},
        mainSource:{id: mainSource, value: mainSource},
        otherSource:other_lead_source,
        photos: photos,
        interactionTypeLead: { id: interaction_type_id, value: interaction_type },
      });
      setLeadsities({
        ...leadsities,
        typeSite: { id: site_type_id, value: site_type },
      });
      setLeadSourceOther(other_poc_sites);
      setTimeout(() => {
        setTypeSubSite({
          id: site_sub_type_id ? site_sub_type_id : '',
          value: site_sub_type,
        });
      }, 100);
    }
  }, [prefilledData]);

  useEffect(() => {
    setLeadDtls({
      ...leadDtls,
      name: client_name,
    });
  },[client_name]);

  useEffect(() => {
    if (supDropDownData) {
      const { poc_site_types } = supDropDownData;
      setSiteType(poc_site_types);
    }
  }, [supDropDownData]);

  useEffect(() => {
    if (appartmentDropDown) {
      // console.log(appartmentDropDown);
      const { sources } = appartmentDropDown;
      setSource(sources);
      const { interaction_type } = appartmentDropDown;
      // console.log(interaction_type);
      setInteractionType(interaction_type);
    }
  }, [appartmentDropDown]);
  useEffect(() => {
    if (corDropDownData) {
      const { sources } = corDropDownData;
      setSource(sources);
    }
  }, [corDropDownData]);
  useEffect(() => {
    if (b2bDropDown) {
      const { sources } = b2bDropDown;
      setSource(sources);
    }
  }, [b2bDropDown]);

  useEffect(() => {
    setTypeSubSite({ id: null, value: '' });
    if (pocSubSiteType && leadsities.typeSite?.id)
      (async () => await pocSubSiteType(leadsities.typeSite?.id))();
  }, [leadsities.typeSite]);

  const handleLeadData = () => {
    console.log(leadDtls);
    if (isSupply === true) {
      const leadsitiesObj = {
        name: leadDtls.name,
        typeSite: leadsities.typeSite.id,
      };
      const isNotEmpty = handleValidateObj(leadsitiesObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...leadsitiesObj,
          catLead: leadsities.catLead,
          typeSubSite: typeSubSite?.id,
          siteSubTypeOther: siteSubTypeOther,
          leadSourceOther: leadSourceOther,
        });
      } else {
        handleValue(null);
      }
    }
    if (leadDtls.sourceLead.value !== '' && isSupply === false) {
      if (isB2bAlliances && !Regex.text.test(leadDtls?.name)) {
        return false;
      }
      handleValue({
        ...leadDtls,
        sourceLead: leadDtls.sourceLead?.id,
        alternateChannle: leadDtls.alternateChannle?.id,
        mainSource: leadDtls.mainSource?.id,
        name: leadDtls.name,
        leadSourceOther: leadSourceOther,
        interactionTypeLead: leadDtls.interactionTypeLead?.id,
        photos: photos,
      });
    } else {
      return false;
    }
  };
  useEffect(() => {
    handleLeadData();
  }, [
    leadDtls,
    prefilledData,
    typeSubSite,
    leadsities,
    siteSubTypeOther,
    leadSourceOther,
    photos,
  ]);

  return (
    <FormSection title={localization.businessDetailsLabel}>
      <div className="form-colo">
      <ConstantInput
        label={inputLabel}
        type="text"
        regex={isB2bAlliances ? Regex.text.test(leadDtls?.name) : null}
        handleChange={(val) => {
          setLeadDtls({ ...leadDtls, name: val });
        }}
        required
        errorMsg={
          isB2bAlliances === ''
            ? localization.requiredClientName
            : localization.requiredCharacter
        }
        value={leadDtls.name}
      />
      <DatePicker
        label={'First Contact Date'}
        handleChange={(val) => setLeadDtls({ ...leadDtls, contact_date: val })}
        maxDate={new Date()}
        value={leadDtls.contact_date}
      />
      {isB2bAlliances === true && (
        <DropDownInput
          data={b2bDropDown && b2bDropDown.poc_site_types}
          label={localization.categoryAlliances}
          getIdValue={(val) => setLeadDtls({ ...leadDtls, tpPoc: val.id })}
          required
          errorMsg={localization.isRequired}
          // value={otherDtlData.categoryAlliances.value}
        />
      )}
      {isSupply === true ? null : (
        <Fragment>
          <DropDownInput
            label={localization.interactionType}
            data={interactionType}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                interactionTypeLead: { id: val.id, value: val.value },
              });
            }}
            required={true}
            errorMsg={localization.requiredInteractionType}
            value={leadDtls.interactionTypeLead.value}
            isStarRequired={true}
          />

          <DropDownInput
            label={localization.LeadSource}
            data={source}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                sourceLead: { id: val.id, value: val.value },
              });
            }}
            required={true}
            errorMsg={localization.requiredLeadSource}
            value={leadDtls.sourceLead.value}
            isStarRequired={true}
          />

          <ConstantInput
              label={localization.brand}
              type="text"
              handleChange={ (val) => {
                setLeadDtls({
                  ...leadDtls,
                  brand: val,
                })}
              }
              value={leadDtls.brand}
          />

          <DropDownInput
              label={localization.typeOfEVCharges}
              data={[{id:"Slow", name:"Slow"}, {id:"Fast", name:"Fast"}]}
              getIdValue={(val) => {
                setLeadDtls({
                  ...leadDtls,
                  type_of_ev_charges: val.id,
                });
              }}
              // required={true}
              value={leadDtls.type_of_ev_charges}
          />

          {leadDtls.sourceLead?.id === 8 && (
            <ConstantInput
              label={localization.otherLeadSource}
              type="text"
              regex={isSupply ? Regex.text.test(leadSourceOther) : null}
              handleChange={(val) => setLeadSourceOther(val)}
              required
              errorMsg={localization.requiredLeadSource}
              value={leadSourceOther}
            />
          )}
          {leadDtls.sourceLead?.id === 11 && (
            <>
                <div className='col-md-12'>
                <DropDownInput
                    label="Alternate Channel"
                    data={[
                      {
                        id: "Enterprise Partner",
                        name: "Enterprise Partner",
                      },
                      {
                        id: "Inbound Channel",
                        name: "Inbound Channel",
                      },
                      {
                        id: "Distribution Partner",
                        name: "Distribution Partner",
                      },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      setLeadDtls({
                        ...leadDtls,
                        alternateChannle: { id: val.id, value: val.value },
                      });
                    }}
                   value={leadDtls.alternateChannle.value}
                    isStarRequired={true}
                />
                </div>
              
              {leadDtls.alternateChannle?.id === 'Enterprise Partner' && (
                <>
                  <DropDownInput
                      label="Main Source"
                      data={[
                        {
                          id: "My Gate",
                          name: "My Gate",
                        },
                        {
                          id: "Adda",
                          name: "Adda",
                        },
                        {
                          id: "I-Society",
                          name: "I-Society",
                        },
                        {
                          id: "ZipGrid",
                          name: "ZipGrid",
                        },
                       
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        setLeadDtls({
                          ...leadDtls,
                          mainSource: { id: val.id, value: val.value },
                        });
                      }}
                   value={leadDtls.mainSource.value}
                      isStarRequired={true}
                  />
                </>
              )}
              {leadDtls.alternateChannle?.id === 'Inbound Channel' && (
                <>
                  <DropDownInput
                      label="Main Source"
                      data={[
                        {
                          id: "Higher Management",
                          name: "Higher Management",
                        },
                        {
                          id: "Digital",
                          name: "Digital",
                        },
                        {
                          id: "Internal Team member",
                          name: "Internal Team member",
                        },
                        {
                          id: "Existing Client",
                          name: "Existing Client",
                        },
                       
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        setLeadDtls({
                          ...leadDtls,
                          mainSource: { id: val.id, value: val.value },
                        });
                      }}
                      isStarRequired={true}
                   value={leadDtls.mainSource.value}
                  />
                </>
              )}
              {leadDtls.alternateChannle?.id === 'Distribution Partner' && (
                <>
                  <DropDownInput
                      label="Main Source"
                      data={[
                        {
                          id: "Individual Partner",
                          name: "Individual Partner",
                        },
                        {
                          id: "SI Partner",
                          name: "SI Partner",
                        },
                        {
                          id: "Other Partner",
                          name: "Other Partner",
                        },                       
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) => {
                        setLeadDtls({
                          ...leadDtls,
                          mainSource: { id: val.id, value: val.value },
                        });
                      }}
                      isStarRequired={true}
                      value={leadDtls.mainSource.value}
                  />
                </>
              )}
              <ConstantInput
                label={localization.otherLeadSource}
                type="text"
                regex={isSupply ? Regex.text.test(leadSourceOther) : null}
                handleChange={(val) => {
                  setLeadDtls({
                    ...leadDtls,
                    otherSource: val,
                  });
                  setLeadSourceOther(val)
                }}
                required
                errorMsg={localization.requiredLeadSource}
                value={leadDtls.otherSource}
                
              />
            </>
             
          )}
           {(prefilledData?.lead_data !== undefined &&
              prefilledData?.lead_data !== null
            ) ? null : 
            <FileUpload
              id="rel_photos"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setPhotos(val.toString())}
              multiple={true}
            >
              <span className="btn btn-transparent">
                {localization.addPhotos}
              </span>
            </FileUpload>
            
            }
         
        </Fragment>
      )}
      {isSupply ? (
        <Fragment>
          <DropDownInput
            label={localization.siteType}
            getIdValue={(val) => {
              setLeadsities({
                ...leadsities,
                typeSite: { id: val.id, value: val.value },
              });
            }}
            data={siteType}
            errorMsg={localization.requiredsiteType}
            required
            value={leadsities.typeSite.value}
          />
          {leadsities.typeSite?.id === 13 && (
            <DropDownInput
              label={localization.siteSubType}
              data={pocSubSiteTypeData && pocSubSiteTypeData}
              getIdValue={(val) => {
                setTypeSubSite({ id: val.id, value: val.value });
              }}
              required={true}
              errorMsg={localization.isRequired}
              value={typeSubSite.value}
            />
          )}
          {typeSubSite.id === 30 && (
            <ConstantInput
              label={localization.clientType}
              type="text"
              regex={isSupply ? Regex.text.test(siteSubTypeOther) : null}
              handleChange={(val) => setSiteSubTypeOther(val)}
              required
              errorMsg={localization.requiredClientType}
              value={siteSubTypeOther}
            />
          )}
        </Fragment>
      ) : null}
      </div>
    </FormSection>
  );
};

LeadDetailsApt.propTypes = {
  isCorporate: PropTypes.bool,
  inputLabel: PropTypes.string,
  isSupply: PropTypes.bool,
  isB2bAlliances: PropTypes.bool,
  isApartment: PropTypes.bool,
  LeadSource: PropTypes.func,
  sourceData: PropTypes.array,
  handleValue: PropTypes.func,
};

export default LeadDetailsApt;
